import {StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {white} from '/theme/color/on.color';
import {alto} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    paddingVertical: indent * 0.4,
    paddingHorizontal: indent * 0.8,
    borderRadius: indent * 0.4,
    borderColor: alto,
    backgroundColor: white,
  },
  loadingBoxSortBy: {
    height: 20,
    width: 80,
  },
  text: {
    marginLeft: indent * 0.4,
    fontSize: 14,
    maxWidth: 150,
  },
});
